import { render, staticRenderFns } from "./UPlaceholder.vue?vue&type=template&id=06e76733&"
import script from "./UPlaceholder.vue?vue&type=script&lang=js&"
export * from "./UPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./UPlaceholder.vue?vue&type=style&index=0&id=06e76733&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports